<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      <!-- 视频选择列表 -->
      <div class="organiza-txt studentList" v-if="listType">
        <div class="organiza-list">
          <div class="list-title">选择视频包</div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>视频名称：</p>
              <input type="text" placeholder="请输入要搜索的文章/题干" v-model="listObj.title">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
          <div class="titleList">
            <p v-for="item in videoTitle" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in videoList" v-bind:key="(index+1)" @click="videoChoose(item,index)">
              <p :title="item.key" class="radio" :class="videoID===index?'select':''">
                <span></span>
              </p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.num">{{item.num}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="listObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="listTotalPage">
            </el-pagination> 
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="VideoSub">确定</button>
          <button class="btn btn-close" @click="videoHide">取消</button>
        </div>
      </div>
      
      <!-- 母题讲解练习 -->
      <div class="MobelBox explainBox" v-else>
        <p class="add-title">母题讲解练习</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="write-txt">
          <div class="videoUpload" v-for="(item,index) in addObj.videos" :key="index">
            <p class="weekTitle">第{{(index+1)}}周：{{item.week_name}}</p>
            <div class="video-item" v-for="(ele,num) in item.list" :key="num" :class="ele.is_update_video==0?'noPointer':''">
              <div class="week-title">
                <p class="write-title"><span>*</span>母题{{(num+1)}}：</p>
                <input type="text" v-model="ele.title">
              </div>
              <button class="btn btn-video-choose" @click="chooseVideo(index,num)">选择视频</button>
              <button class="btn btn-video-add" @click="addVideo(index,num)">+添加视频</button>
              <button class="btn btn-video-add" @click="removeShow(index,num)" v-if="num>0">删除</button>
              <div class="write-text" v-for="(i,k) in ele.video" :key="k">
                <p>第{{(k+1)}}小结：{{i.title}}</p>
                <video :src="'https://pic.bi-rong.com/'+i.video"  @click="lookVideo(i)"></video>
              </div>
            </div>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>

    <!-- 观看视频 -->
    <div class="msgBox videoMsg" v-if="videoType">
      <div class="contv">
          <button class="btn btn-video" @click="videoClose"></button>
          <video :src="'https://pic.bi-rong.com/'+videoUrl" controls></video>
      </div>
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVideoPackageSelectList,saveReadVideo ,getReadDetail} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import axios from "axios"
export default {
  name: "index",
  data() {
    return {
      navId:'8',
      childrenID:'8-1',
      videoTitle:[
        {id:1,title:''},
        {id:2,title:'视频名称'},
        {id:3,title:'小节数'},
      ],
      addType:'',
      listObj:{
        page:1,
        rows:10
      },
      token:'',
      addObj:{},
      totalPage:0,
      listTotalPage:0,
      url:'',
      explainType:false,
      listType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      videoList:[],
      videoData:'',
      videoIndex:'',
      weekIndex:'',
      videoID:'',
      removeType:false,
      removeID:[],
      url:'',
      videoType:false,
      videoUrl:'',
      is_up:1
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.is_up = this.$route.query.is_up
    this.getToken();
    this.getDetail();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.chooseVideo();
    },

    async getDetail(e,type){
      var that = this;      
      var id = this.$route.query.id
      try {
        const response = await getReadDetail({id:id,type:2},this.token);
        if(response.code == 200){
          response.data.videos.forEach(function(item,index){
            if(item.list.length == 0){
              item.list.push({content:'',video:[]})
            }
          })
          that.addObj.videos = response.data.videos;
          console.log(that.addObj)
          that.addObj.id = id;
          that.$forceUpdate();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    getToken(){
      var that = this;
      var url = this.$refs.navBox.url;
      axios({
        url: url+'/api/upload/getUploadToken',
        method:'post', 
      }).then((arr) => {
        if(arr.data.code == 200){
          that.uploadObj.token = arr.data.data.token
        } else {
          that.$message(arr.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },

    async switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        status:e.status==false?0:1,
      };
      try {
        const response = await updatePracticeTypeStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      // if(this.addObj.title == ''){
      //   that.$message('请填写标题！');
      //   return false;
      // }
      // if(this.addObj.begin_date == ''){
      //   that.$message('请选择开始时间！');
      //   return false;
      // }
      // if(this.addObj.end_date == ''){
      //   that.$message('请选择结束时间！');
      //   return false;
      // }
      console.log(this.addObj,'addObj');
      try {
        const response = await saveReadVideo(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.$router.push('/marketIndex')   
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.$router.push('/marketIndex');
    },

    searchSub(){
      this.listObj.page = 1;
      this.chooseVideo();
    },

    resetSub(){
      this.listObj={
        page:1,
        rows:10,
      };
      this.listTotalPage = 0;
      this.chooseVideo();
    },

    addTopic(){
      var list = {
        topic:'',
        topic_type:'',
        answer:'',
        topic_label_one:'',
        topic_label_two:'',
        topic_label_three:'',
      }
      this.addObj.topic.push(list);
    },

    removeTopic(e,i){
      this.addObj.topic.splice(i,1)
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUploadVideo(file,item) {
      console.log(file,item,'====filefilefile==')
      var url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata",
          function () {
            console.log(parseInt(audioElement.duration))
            item.total_time = parseInt(audioElement.duration)
      });

      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessVideo(response, file, fileList,e,type,num) {
      e.video = response.key;
      console.log(e,'==file==')
      this.loading = false;
      this.uploadObj.key = "";
    },

    handleRemoveVideo(response, file, fileList,index,type,num) {
      if(type == 'video'){
        this.examObj.level[index].image_videos[num].static_video = '';
      } else {
        this.examObj.level[index].image_videos[num].video = '';
      }
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    videoChoose(e,i){
      console.log(this.addObj.videos,'==this.addObj.videos==')
      console.log(this.weekIndex,this.videoIndex,'==e==')
      this.videoID = i;
      this.addObj.videos[this.weekIndex].list[this.videoIndex].title = e.title;
      this.addObj.videos[this.weekIndex].list[this.videoIndex].explain = e.explain;
      this.addObj.videos[this.weekIndex].list[this.videoIndex].content = e.content;
      this.addObj.videos[this.weekIndex].list[this.videoIndex].topic = e.topic;
      this.addObj.videos[this.weekIndex].list[this.videoIndex].video = e.video;
      this.$forceUpdate();
      console.log(this.addObj,'==addObj==')
    },

    VideoSub(){
      var that = this;
      this.listType = false;
      this.videoID = '';
      console.log(this.addObj.videos,'===that.videoList==')
    },

    videoHide(){
      this.listType = false;
      this.videoList = [];
    },

    async chooseVideo(index,num){
      if(index || index >= 0){
        this.weekIndex = index;
      }
      if(num || num>=0){
        this.videoIndex = num;
      }
      console.log(this.weekIndex,this.videoIndex,index,num)
      var that = this;      
      try {
        const response = await getVideoPackageSelectList(this.listObj,this.token);
        if(response.code == 200){
          that.videoList = response.data.list;
          that.listType = true;
          that.listTotalPage = response.data.total_page;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addVideo(index,num){
      this.addObj.videos[index].list.push({content:'',video:[]});
      this.$forceUpdate();
    },

    removeShow(index,num){
      this.removeID = [index,num];
      this.removeType = true;
    },

    async removeSub(){
      var index = this.removeID[0];
      var num = this.removeID[1];
      this.addObj.videos[index].list.splice(num,1);
      this.$forceUpdate();
      this.removeType = false;
    },

    lookVideo(e){
      console.log(e,'eeee')
      this.videoType = true;
      this.videoUrl = e.video;
    },

    videoClose(){
      this.videoType = false;
      this.videoUrl = '';
    },
  }

 

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 10 );
  }

  /* .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 10px;
  } */

  .add-title,
  .list-title{
    color: #333333;
    font-size: 24px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .MobelBox .write-ai .write-text{
    width: auto;
  }

  .studentList>>> .el-radio__inner{
    width: 20px;
    height: 20px;
    border-width:  2px;
  }

  .studentList>>> .el-radio__label{
    font-size: 18px;
    display: none;
  }

  .studentList>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

  .organiza-txt>>>.el-upload{
    width: 100%;
    display: block;
  }

  .organiza-txt>>>.el-button--small span{
    width: 100%;
    text-align: center;
    display: block;
  }

  .organiza-txt>>>.el-button--primary{
    background-color: transparent;
    border: none;
    font-size: 15px;
  }

  .btn-topic-add{
    font-size: 16px;
    color: #6098F2;
    margin-top: 30px;
    display: block;  
    border: solid 1px #6098F2;
    border-radius: 6px;
    padding: 5px 15px;
    box-sizing: border-box;
  }


.videoUpload{
  font-size: 0;
  margin-top: 30px;
}

.videoUpload .weekTitle{
  font-size: 20px;
  position: relative;
  margin: 0 0 20px 45px;
}


.videoUpload .weekTitle::before{
  content: '';
  width: 5px;
  height: 18px;
  background-color: #6098F2;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(0,-50%);
  transform: translate(0,-50%);
  left: -15px;
}

.videoUpload .video-item{
  padding: 0 70px;
  box-sizing: border-box;
  margin-top: 20px;
}

.videoUpload .video-item .write-text video{
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
  width: 200px;
}


.btn-video-add{
  font-size: 16px;
  color: #6098F2;
  padding: 5px 20px;
  border-radius: 6px;
  background-color: transparent;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
  border: solid 1px #6098F2;
  color: #6098F2;
}

.btn-video-choose{
  font-size: 16px;
  color: #333333;
  padding: 5px 20px;
  border-radius: 6px;
  background-color: transparent;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
  border: solid 1px #333;
}

.MobelBox.explainBox .write-text{
  width: auto;
  display: block;
  margin: 10px 0;
}

.MobelBox.explainBox .write-text p{
  font-size: 18px;
  color: #333333;
  margin-bottom: 15px;
}

.studentList .searchBox {
  padding: 0;
  margin-top: 25px;
  float: none;
}

.studentList .searchBox .search-item p{
  width: 80px;
  padding: 0;
}

.studentList .titleList{
  background-color: #F0F4FB;
  margin-top: 20px;
}

.studentList .dataList .listItem p,
.studentList .organiza-list p{
  width: calc( 100% / 3 );
}

.studentList .dataList .listItem p.radio span{
  width: 20px;
  height: 20px;
  background-color: #D9D9D9;
  border-radius: 4px;
  display: block;
}

.studentList .dataList .listItem p.select span{
  background-color: #6098F2;
}

.studentList .dataList .listItem p.select span::before{
  content: '✔';
  width: 20px;
  height: 20px;
  display: block;
  color: #ffff;
  margin: 0 5px;
}

.msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.msgBox.videoMsg .btn-video{
  background-image: url(~@/assets/images/btn-close.png);
}

.week-title{
  display: inline-block;
  font-size: 0;
  margin-bottom: 20px;
}

.week-title input,
.week-title p{
  display: inline-block;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/marketing/explain.vue